import { render, staticRenderFns } from "./CreativesV2.vue?vue&type=template&id=0f6c09ac&scoped=true&"
import script from "./CreativesV2.vue?vue&type=script&lang=js&"
export * from "./CreativesV2.vue?vue&type=script&lang=js&"
import style0 from "./CreativesV2.vue?vue&type=style&index=0&id=0f6c09ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6c09ac",
  null
  
)

export default component.exports